export type RefreshOutcome = "refreshed" | "temporary-failure" | "session-ended";

export interface RefreshResult {
    outcome: RefreshOutcome;
    token: string | null;
}

// /auth/web/refresh answers through axios.defaults.validateStatus (200-504 resolve, main.ts),
// so HTTP errors arrive here, not as rejections. A rejected refresh token is 400/401 or an
// error body; anything else may succeed on the next try.
export function classifyRefreshResponse(status: number, data: unknown): RefreshOutcome {
    const hasError = !!data && typeof data === "object" && "error" in data && !!data.error;
    if (status === 200 && data && !hasError) return "refreshed";
    if (status === 400 || status === 401 || hasError) return "session-ended";
    return "temporary-failure";
}

// Every call made while a run is in flight gets that run's promise. The slot clears when the
// run settles, success or failure, so the next call starts a new run.
export function createSharedRefresh(run: () => Promise<RefreshResult>): () => Promise<RefreshResult> {
    let inFlight: Promise<RefreshResult> | null = null;
    return () => {
        if (!inFlight) {
            inFlight = run()
                .catch((): RefreshResult => ({ outcome: "temporary-failure", token: null }))
                .then(result => {
                    inFlight = null;
                    return result;
                });
        }
        return inFlight;
    };
}
